/**
 * Created by CoolGuy on 2017/4/11.
 */
const DEMO = "DEMO";
const SHOW_IM = "SHOW_IM";
const SHOW_ADD_GALLERY = "SHOW_ADD_GALLERY";//显示创建子相册页面
const SHOW_ADD_USER = "SHOW_ADD_USER";//显示/隐藏新增用户页面
const SHOW_PERMISSION_LIST = "SHOW_PERMISSION_LIST";//显示权限列表
const SHOW_ORDER_DETAIL = "SHOW_ORDER_DETAIL";//显示订单详情
const SHOW_ADD_DEPARTMENT = "SHOW_ADD_DEPARTMENT";
const SHOW_ADD_PRODUCT = "SHOW_ADD_PRODUCT";
const SHOW_ALLOCATION_MODAL = "SHOW_ALLOCATION_MODAL";
const SHOW_ADD_COMMON = "SHOW_ADD_COMMON";//通用的新增窗口
const SHOW_ADD_CONTACT = "SHOW_ADD_CONTACT";
const SHOW_ADD_CONSUMER = "SHOW_ADD_CONSUMER";
const SHOW_PRODUCT_DETAIL = "SHOW_PRODUCT_DETAIL";
const SHOW_ADD_REDPACKAGE_BALANCE = "SHOW_ADD_REDPACKAGE_BALANCE";
const SHOW_ADD_REDPACKAGE_POST = "SHOW_ADD_REDPACKAGE_POST";
const SHOW_COMMON_DETAIL = "SHOW_COMMON_DETAIL";//考虑到每个页面基本上只有一个右侧划入，所以没有特别定制的情况下，可以直接用这个来控制
const FILL_CURRENT_USER = "FILL_CURRENT_USER";//填充当前的用户信息（用于编辑用户）
const FILL_CURRENT_ORDER = "FILL_CURRENT_ORDER";//填充当前的订单信息
const REMOVE_CURRENT_USER = "REMOVE_CURRENT_USER";//删除当前填充的用户
const REMOVE_CURRENT_ORDER = "REMOVE_CURRENT_ORDER";//
const REMOVE_CURRENT_PRODUCT = "REMOVE_CURRENT_PRODUCT";
const REMOVE_CURRENT_REMIT = "REMOVE_CURRENT_REMIT";
const REMOVE_CURRENT_OPPO = "REMOVE_CURRENT_OPPO";
const REMOVE_CURRENT_CLUE = "REMOVE_CURRENT_CLUE";
const REMOVE_CURRENT_GALLERY = "REMOVE_CURRENT_GALLERY";
const REMOVE_CURRENT_BILL= "REMOVE_CURRENT_BILL";
const REMOVE_CURRENT_AGREEMENT = "REMOVE_CURRENT_AGREEMENT";
const REMOVE_CURRENT_CONSUMER = "REMOVE_CURRENT_CONSUMER";
const REMOVE_CURRENT_CONTACT = "REMOVE_CURRENT_CONTACT";
const REMOVE_CURRENT_PROXY = "REMOVE_CURRENT_PROXY";
const REMOVE_CURRENT_REDPACKAGE_BALANCE = "REMOVE_CURRENT_REDPACKAGE_BALANCE";
const REMOVE_CURRENT_REDPACKAGE = "REMOVE_CURRENT_REDPACKAGE";
const REMOVE_CURRENT_CHECK = "REMOVE_CURRENT_CHECK";
const REMOVE_CURRENT_TOOL = "REMOVE_CURRENT_TOOL";
const CHECK_RIGHT_DETAIL_SHOW = "CHECK_RIGHT_DETAIL_SHOW";
const FULL_CONTENT = "FULL_CONTENT";

const ORDER_EDIT_BY_KEY = "ORDER_EDIT_BY_KEY";//按照键值对的方式编辑订单数据
const ORDER_COPY = "ORDER_COPY";//订单拷贝

export default {
    DEMO,
    demo:(data)=>({
        type:DEMO,
        data,
    }),
    FULL_CONTENT,
    fullContent:(flag)=>({
        type:FULL_CONTENT,
        flag
    }),
    SHOW_COMMON_DETAIL,
    showCommonDetail: (flag)=>({
        type:SHOW_COMMON_DETAIL,
        flag
    }),
    SHOW_IM,
    showIMDetail:(flag)=>({
        type:SHOW_IM,
        flag
    }),
    SHOW_ADD_GALLERY,
    showAddGallery:(flag)=>({
        type:SHOW_ADD_GALLERY,
        flag
    }),
    SHOW_ADD_USER,
    showAddUser: (flag)=>({
        type:SHOW_ADD_USER,
        flag
    }),
    SHOW_ADD_DEPARTMENT,
    showAddDepartment: (flag, current)=>({
        type:SHOW_ADD_DEPARTMENT,
        flag,
        current
    }),
    SHOW_ALLOCATION_MODAL,
    showAllocationModal:(flag)=>({
        type:SHOW_ALLOCATION_MODAL,
        flag,
    }),
    SHOW_ADD_COMMON,
    showAddCommon: (flag, info)=>({
        type:SHOW_ADD_COMMON,
        flag,
        info
    }),
    SHOW_ADD_CONSUMER,
    showAddConsumer:(flag)=>({
        type:SHOW_ADD_CONSUMER,
        flag,
    }),
    SHOW_PERMISSION_LIST,
    showPermissionList:(flag)=>({
        type:SHOW_PERMISSION_LIST,
        flag
    }),
    SHOW_ORDER_DETAIL,
    showOrderDetail:(flag)=>({
        type:SHOW_ORDER_DETAIL,
        flag
    }),
    SHOW_ADD_PRODUCT,
    showAddProduct:(flag)=>({
        type:SHOW_ADD_PRODUCT,
        flag,
    }),
    SHOW_PRODUCT_DETAIL,
    showProductDetail:(flag)=>({
        type:SHOW_PRODUCT_DETAIL,
        flag,
    }),
    SHOW_ADD_REDPACKAGE_BALANCE,
    showAddRedpackageBalance:(flag)=>({
        type:SHOW_ADD_REDPACKAGE_BALANCE,
        flag,
    }),
    SHOW_ADD_REDPACKAGE_POST,
    showAddRedpackagePost:(flag)=>({
        type:SHOW_ADD_REDPACKAGE_POST,
        flag,
    }),
    FILL_CURRENT_USER,
    fillCurrentUser:(record)=>({
        type:FILL_CURRENT_USER,
        record
    }),
    FILL_CURRENT_ORDER,
    fillCurrentOrder:(data)=>({
        type:FILL_CURRENT_ORDER,
        data
    }),
    REMOVE_CURRENT_USER,
    removeCurrentUser:()=>({
        type:REMOVE_CURRENT_USER,
    }),
    REMOVE_CURRENT_ORDER,
    removeCurrentOrder:()=>({
        type:REMOVE_CURRENT_ORDER
    }),
    REMOVE_CURRENT_GALLERY,
    removeCurrentGallery:()=>({
        type:REMOVE_CURRENT_GALLERY
    }),
    REMOVE_CURRENT_PRODUCT,
    removeCurrentProduct:()=>({
        type:REMOVE_CURRENT_PRODUCT
    }),
    REMOVE_CURRENT_REMIT,
    removeCurrentRemit:()=>({
        type:REMOVE_CURRENT_REMIT,
    }),
    REMOVE_CURRENT_OPPO,
    removeCurrentOppo:()=>({
        type:REMOVE_CURRENT_OPPO,
    }),
    REMOVE_CURRENT_CLUE,
    removeCurrentClue:()=>({
        type:REMOVE_CURRENT_CLUE,
    }),
    REMOVE_CURRENT_BILL,
    removeCurrentBill:()=>({
        type:REMOVE_CURRENT_BILL,
    }),
    REMOVE_CURRENT_AGREEMENT,
    removeCurrentAgreement:()=>({
        type:REMOVE_CURRENT_AGREEMENT,
    }),
    ORDER_EDIT_BY_KEY,
    orderEditByKey:(key,value)=>({
        type:ORDER_EDIT_BY_KEY,
        key,value
    }),
    REMOVE_CURRENT_CONSUMER,
    removeCurrentConsumer:()=>({
        type:REMOVE_CURRENT_CONSUMER
    }),
    REMOVE_CURRENT_CONTACT,
    removeCurrentContact:()=>({
        type:REMOVE_CURRENT_CONTACT,
    }),
    REMOVE_CURRENT_PROXY,
    removeCurrentProxy:()=>({
        type:REMOVE_CURRENT_PROXY,
    }),
    REMOVE_CURRENT_REDPACKAGE_BALANCE,
    removeCurrentRedpackageBalance:()=>({
        type:REMOVE_CURRENT_REDPACKAGE_BALANCE,
    }),
    REMOVE_CURRENT_REDPACKAGE,
    removeCurrentRedpackage:()=>({
        type:REMOVE_CURRENT_REDPACKAGE
    }),
    REMOVE_CURRENT_CHECK,
    removeCurrentCheck:()=>({
        type:REMOVE_CURRENT_CHECK
    }),
    REMOVE_CURRENT_TOOL,
    removeCurrentTool:()=>({
        type:REMOVE_CURRENT_TOOL
    }),
    ORDER_COPY,
    orderCopy:(data)=>({
        type:ORDER_COPY,
        data,
    }),
    CHECK_RIGHT_DETAIL_SHOW,
    checkRightDetailShow:(flag)=>({
        type:CHECK_RIGHT_DETAIL_SHOW,
        flag,
    })
}



// WEBPACK FOOTER //
// ./src/actions/index.js